import { FormFieldSchema } from '../../../components/FormRenderer/types';
import { RoleGroups } from '../../../utils/roleAccess';
import { initialPaymentConfigData } from './constant';

const featureConfigWithExtraValues: FormFieldSchema[] = Object.keys(
  initialPaymentConfigData.featureConfigs ?? {}
).flatMap((key) => {
  const feature = (
    initialPaymentConfigData.featureConfigs as Record<string, any>
  )[key];
  const featureKey = key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
  const children: FormFieldSchema[] = [
    {
      name: `featureConfigs.${key}.enabled`,
      label: featureKey,
      type: 'checkbox',
      gridProps: { xs: 12, sm: key === 'enachPayment' ? 12 : 4 }
    }
  ];
  if (feature.offsetDays && key !== 'enachPayment') {
    children.push({
      name: `featureConfigs.${key}.offsetDays`,
      label: `${featureKey} Offset Days`,
      type: 'multi-value-input',
      placeholder: 'Enter offset days and press enter to add new',
      shouldRender: (formData) =>
        formData.featureConfigs.installmentPaymentLink.enabled
    });
  }
  return children;
});

export function getPaymentConfigSchema(gradeOptions: any): FormFieldSchema[] {
  return [
    {
      name: 'general',
      label: 'General',
      type: 'section',
      allowedRoles: RoleGroups.ALL_ADMINS,
      children: [
        {
          name: 'receiptTemplateId',
          label: 'Receipt Template Id',
          type: 'input',
          placeholder: 'Receipt Template Id',
          allowedRoles: RoleGroups.ALL_ADMINS
        },
        {
          name: 'logoUrl',
          label: 'Payment Logo',
          type: 'fileUpload',
          title: 'Payment Logo',
          allowedRoles: RoleGroups.ALL_ADMINS,
          uploadFor: 'receipt'
        }
      ]
    },
    {
      name: 'razorpay',
      label: 'Razorpay configuration',
      type: 'section',
      allowedRoles: RoleGroups.ALL_ADMINS,
      children: [
        {
          name: 'razorpay.apiUsername',
          label: 'Username',
          type: 'input',
          placeholder: 'Api Username',
          allowedRoles: RoleGroups.ALL_ADMINS
        },
        {
          name: 'razorpay.apiPassword',
          label: 'Password',
          type: 'input',
          placeholder: 'Api Password',
          allowedRoles: RoleGroups.ALL_ADMINS
        }
      ]
    },
    {
      name: 'gradeWiseConfig',
      label: 'Grade Wise Config',
      type: 'array',
      itemTemplate: {
        schoolName: '',
        schoolAddress: '',
        razorpaySubMerchantId: '',
        grades: [],
      },
      allowedRoles: RoleGroups.ALL_ADMINS,
      children: [
        {
          name: 'schoolName',
          label: 'School Name',
          type: 'input',
          placeholder: 'Enter school name',
          allowedRoles: RoleGroups.ALL_ADMINS
        },
        {
          name: 'schoolAddress',
          label: 'School Address',
          type: 'input',
          placeholder: 'Enter school address',
          allowedRoles: RoleGroups.ALL_ADMINS
        },
        {
          name: 'razorpaySubMerchantId',
          label: 'Razorpay SubMerchant Id',
          type: 'input',
          placeholder: 'Enter rapzorpay submerchant id',
          allowedRoles: RoleGroups.ALL_ADMINS
        },
        {
          name: 'grades',
          label: 'Grades',
          type: 'multiSelect',
          options: gradeOptions,
          allowedRoles: RoleGroups.ALL_ADMINS
        }
      ]
    },
    {
      name: 'featureConfigs',
      label: 'Feature Flags',
      type: 'section',
      children: featureConfigWithExtraValues,
      allowedRoles: RoleGroups.ALL_ADMINS
    }
  ];
}
